module.exports = __webpack_public_path__ + "img/patients_black.71b4fa7f.svg";